import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Box, Divider, Grid, Stack, Typography } from "@mui/material";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
// import { DesktopTabComponent } from "../../../../components/molecules/desktopTabComponent";
import { secondary } from "../../../../theme/colors";
import { useAppSelector } from "../../../../store/hooks";
var COLORS = ["#3697FF", "#FFAB00", "#1DC8DF", "#52C41A", "#1B1D21"];
var AFRCOLORS = ["#3697FF", "#EB6A2C", "#52C41A", "#FFAB00", "#1DC8DF", "#1B1D21"];
var RADIAN = Math.PI / 180;
var renderCustomizedLabel = function (_ref) {
    var _data$index$count, _data$index;
    var cx = _ref.cx, cy = _ref.cy, midAngle = _ref.midAngle, innerRadius = _ref.innerRadius, outerRadius = _ref.outerRadius, index = _ref.index, data = _ref.data;
    var radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    var x = cx + radius * Math.cos(-midAngle * RADIAN);
    var y = cy + radius * Math.sin(-midAngle * RADIAN);
    var count = (_data$index$count = (_data$index = data[index]) === null || _data$index === void 0 ? void 0 : _data$index.count) !== null && _data$index$count !== void 0 ? _data$index$count : 0;
    return /*#__PURE__*/ React.createElement("text", {
        x: x,
        y: y,
        fill: "white",
        textAnchor: "middle",
        dominantBaseline: "central",
        fontSize: 12
    }, count);
};
export var PSGDashboard = function () {
    var crud = useAppSelector(function (state) { return state.crud; });
    var FFRDATA = crud === null || crud === void 0 ? void 0 : crud.DashboardCountForASM;
    var AFRDATA = crud === null || crud === void 0 ? void 0 : crud.DashboardCountAFRASM;
    var UPDATED_AFRDATA = crud === null || crud === void 0 ? void 0 : crud.updateDashboardCountAFR;
    var UPDATED_FFRDATA = crud === null || crud === void 0 ? void 0 : crud.updateDashboardCount;
    console.log("AFR DATA", AFRDATA);
    var FFRCount = !UPDATED_FFRDATA ? [{
            name: "Received",
            count: FFRDATA === null || FFRDATA === void 0 ? void 0 : FFRDATA.ReceivedCount
        }, {
            name: "Reverted",
            count: FFRDATA === null || FFRDATA === void 0 ? void 0 : FFRDATA.RevertedCount
        }, {
            name: "Closed",
            count: FFRDATA === null || FFRDATA === void 0 ? void 0 : FFRDATA.ClosedCount
        }, {
            name: "Lapsed",
            count: FFRDATA === null || FFRDATA === void 0 ? void 0 : FFRDATA.LapsedCount
        }, {
            name: "Corrective Action Taken",
            count: FFRDATA === null || FFRDATA === void 0 ? void 0 : FFRDATA.ClosedCount
        }] : [{
            name: "Received",
            count: UPDATED_FFRDATA === null || UPDATED_FFRDATA === void 0 ? void 0 : UPDATED_FFRDATA.ReceivedCount
        }, {
            name: "Reverted",
            count: UPDATED_FFRDATA === null || UPDATED_FFRDATA === void 0 ? void 0 : UPDATED_FFRDATA.RevertedCount
        }, {
            name: "Closed",
            count: UPDATED_FFRDATA === null || UPDATED_FFRDATA === void 0 ? void 0 : UPDATED_FFRDATA.ClosedCount
        }, {
            name: "Lapsed",
            count: UPDATED_FFRDATA === null || UPDATED_FFRDATA === void 0 ? void 0 : UPDATED_FFRDATA.LapsedCount
        }, {
            name: "Corrective Action Taken",
            count: UPDATED_FFRDATA === null || UPDATED_FFRDATA === void 0 ? void 0 : UPDATED_FFRDATA.ClosedCount
        }];
    var AFRCount = !UPDATED_AFRDATA ? [{
            name: "Open",
            count: AFRDATA === null || AFRDATA === void 0 ? void 0 : AFRDATA.Open
        }, {
            name: "Grouped",
            count: AFRDATA === null || AFRDATA === void 0 ? void 0 : AFRDATA.Submitted
        }, {
            name: "Reverted",
            count: AFRDATA === null || AFRDATA === void 0 ? void 0 : AFRDATA.Reverted
        }, {
            name: "Closed",
            count: AFRDATA === null || AFRDATA === void 0 ? void 0 : AFRDATA.Closed
        }, {
            name: "Lapsed",
            count: AFRDATA === null || AFRDATA === void 0 ? void 0 : AFRDATA.LapsedCount
        }, {
            name: "Resubmitted",
            count: AFRDATA === null || AFRDATA === void 0 ? void 0 : AFRDATA.LapsedCount
        }] : [{
            name: "Open",
            count: UPDATED_AFRDATA === null || UPDATED_AFRDATA === void 0 ? void 0 : UPDATED_AFRDATA.Open
        }, {
            name: "Grouped",
            count: UPDATED_AFRDATA === null || UPDATED_AFRDATA === void 0 ? void 0 : UPDATED_AFRDATA.Submitted
        }, {
            name: "Reverted",
            count: UPDATED_AFRDATA === null || UPDATED_AFRDATA === void 0 ? void 0 : UPDATED_AFRDATA.Reverted
        }, {
            name: "Closed",
            count: UPDATED_AFRDATA === null || UPDATED_AFRDATA === void 0 ? void 0 : UPDATED_AFRDATA.Closed
        }, {
            name: "Lapsed",
            count: UPDATED_AFRDATA === null || UPDATED_AFRDATA === void 0 ? void 0 : UPDATED_AFRDATA.LapsedCount
        }, {
            name: "Resubmitted",
            count: UPDATED_AFRDATA === null || UPDATED_AFRDATA === void 0 ? void 0 : UPDATED_AFRDATA.LapsedCount
        }];
    return /*#__PURE__*/ React.createElement(Grid, {
        width: "100%"
    }, /*#__PURE__*/ React.createElement(Stack, {
        minHeight: "inherit",
        width: "100%",
        direction: {
            xs: "column",
            md: "row"
        },
        gap: 2,
        justifyContent: "center",
        p: "10px"
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        minWidth: 200,
        gap: 2,
        display: "flex",
        justifyContent: "center",
        p: "10px",
        xs: 12,
        md: 6
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            backgroundColor: "white",
            borderRadius: 2,
            boxShadow: 1,
            p: 2,
            width: {
                xs: window.innerWidth / 1,
                sm: window.innerWidth / 1,
                md: window.innerWidth / 2.4,
                xl: window.innerWidth / 2.2
            }
        }
    }, /*#__PURE__*/ React.createElement(Stack, {
        direction: "row",
        justifyContent: "space-between",
        sx: {
            alignItems: "center"
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h1",
        fontWeight: "bold",
        sx: {
            textWrap: "wrap",
            width: {
                xs: "50%",
                md: "100%"
            }
        }
    }, "FFRs")), /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            my: 2
        }
    }), /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        alignItems: "center",
        justifyContent: "space-between"
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        sm: 8,
        xs: 12
    }, /*#__PURE__*/ React.createElement(PieData, {
        data: FFRCount,
        colors: COLORS,
        delay: 1000,
        options: {
            responsive: true,
            maintainAspectRatio: false
        }
    }))))), /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        minWidth: 200,
        gap: 2,
        display: "flex",
        justifyContent: "center",
        p: "10px",
        xs: 12,
        md: 6
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            backgroundColor: "white",
            borderRadius: 2,
            boxShadow: 1,
            p: 2,
            width: {
                xs: window.innerWidth / 1,
                sm: window.innerWidth / 1,
                md: window.innerWidth / 2.4,
                xl: window.innerWidth / 2.2
            }
        }
    }, /*#__PURE__*/ React.createElement(Stack, {
        direction: "row",
        justifyContent: "space-between",
        sx: {
            alignItems: "center"
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h1",
        fontWeight: "bold",
        sx: {
            textWrap: "wrap",
            width: {
                xs: "50%",
                md: "100%"
            }
        }
    }, "AFRs")), /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            my: 2
        }
    }), /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        alignItems: "center",
        justifyContent: "space-between"
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        sm: 8,
        xs: 12
    }, /*#__PURE__*/ React.createElement(PieData, {
        data: AFRCount,
        colors: AFRCOLORS,
        delay: 1000,
        options: {
            responsive: true,
            maintainAspectRatio: false
        }
    })))))));
};
var PieData = function (props) {
    var data = props.data, colors = props.colors, headerLabel = props.headerLabel, delay = props.delay;
    var total = data.reduce(function (sum, item) {
        var count = typeof item.count === 'number' ? item.count : 0;
        return sum + count;
    }, 0);
    return /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 2
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        sm: 8,
        xs: 12
    }, /*#__PURE__*/ React.createElement(ResponsiveContainer, {
        width: "100%",
        height: 300
    }, /*#__PURE__*/ React.createElement(PieChart, null, /*#__PURE__*/ React.createElement(Pie, {
        data: data,
        cx: "50%",
        cy: "50%",
        innerRadius: 60,
        outerRadius: 130,
        paddingAngle: 0,
        dataKey: "count",
        label: function (props) { return renderCustomizedLabel(_objectSpread(_objectSpread({}, props), {}, {
            data: data
        })); },
        labelLine: false
    }, data.map(function (entry, index) { /*#__PURE__*/ return React.createElement(Cell, {
        key: "cell-".concat(index),
        fill: colors[index % colors.length]
    }); })), /*#__PURE__*/ React.createElement("text", {
        x: "50%",
        y: "50%",
        textAnchor: "middle",
        dominantBaseline: "middle",
        fontSize: 20,
        fontWeight: "bold"
    }, total)))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        sm: 4,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Stack, {
        spacing: 1
    }, data.map(function (item, index) { /*#__PURE__*/ return React.createElement(Stack, {
        direction: "row",
        spacing: 1,
        alignItems: "center",
        key: index
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            width: 35,
            height: 35,
            backgroundColor: colors[index] || "#CCC",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "10px",
            fontWeight: "bold",
            color: "#fff"
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        fontWeight: "medium",
        color: secondary[500]
    }, item.name.length > 10 ? item.name.substring(0, 15) + "..." : item.name)); }))));
};
